export enum SlaApiName {
  AuthLogin = 'auth_login',
  AuthOtp = 'auth_otp',
  Award = 'award',
  Personalization = 'personalization',
  PublisherEvents = 'publisher_events',
  CheckoutSession = 'checkout_session'
}

export interface IApiPerformanceIndicator {
  p95TotalDurationMs: number | null;
  p95AppchargeProcessingDurationMs: number | null;
  p95PublisherProcessingDurationMs: number | null;
}

export interface IApiPerformanceTimeSeriesPoint {
  date: string;
  p95TotalDurationMs: number | null;
  p95AppchargeProcessingDurationMs: number | null;
  p95PublisherProcessingDurationMs: number | null;
}

export interface IApiPerformanceApiMetric {
  apiName: SlaApiName;
  displayName: string;
  indicator: IApiPerformanceIndicator;
  timeSeries: IApiPerformanceTimeSeriesPoint[];
}

export interface IApiPerformancePageResponse {
  publisherId: string;
  month: string;
  apiMetrics: IApiPerformanceApiMetric[];
}

export enum ApiPerformanceSegmentKey {
  AppchargeProcessing = 'appchargeProcessing',
  PublisherProcessing = 'publisherProcessing'
}
